import request from '@/utils/request'

export const getAimUsers = (params: {
  page?: number
  limit?: number
  startDate?: string
  endDate?: string
  userId?: string
}) =>
  request({
    url: '/admin/aim/users',
    method: 'get',
    params
  })

export const getAimUserDaily = (userId: string, params: {
  startDate?: string
  endDate?: string
}) =>
  request({
    url: `/admin/aim/users/${userId}/daily`,
    method: 'get',
    params
  })

export const getAimStats = () =>
  request({
    url: '/admin/aim/stats',
    method: 'get'
  })

export const getAimUserRecords = (userId: string, params: {
  date?: string
  page?: number
  limit?: number
}) =>
  request({
    url: `/admin/aim/users/${userId}/records`,
    method: 'get',
    params
  })

// Trainer-Trainee Relationships (legacy, single-direction)
export const getTrainerTraineeRelationships = () =>
  request({
    url: '/admin/mobility/trainer-trainee',
    method: 'get'
  })

// =============== AIM Groups (bidirectional trainer/trainee) ===============

export interface AimGroupStudent {
  userId: string
  firstName: string
  lastName: string
  email: string
}

export interface AimGroup {
  teacherId: string
  teacherFirstName: string
  teacherLastName: string
  teacherEmail: string
  programStatus: string | null
  createdAt: string | null
  updatedAt: string | null
  students: AimGroupStudent[]
  studentCount: number
}

export const listAimGroups = () =>
  request({
    url: '/admin/aim/groups',
    method: 'get'
  })

export const getAimGroupDetail = (teacherId: string) =>
  request({
    url: `/admin/aim/groups/${teacherId}`,
    method: 'get'
  })

export const createAimGroup = (data: { teacherId: string, studentIds: string[] }) =>
  request({
    url: '/admin/aim/groups',
    method: 'post',
    data
  })

export const addStudentsToAimGroup = (teacherId: string, studentIds: string[]) =>
  request({
    url: `/admin/aim/groups/${teacherId}/students`,
    method: 'post',
    data: { studentIds }
  })

export const removeStudentFromAimGroup = (teacherId: string, studentId: string) =>
  request({
    url: `/admin/aim/groups/${teacherId}/students/${studentId}`,
    method: 'delete'
  })

// External API Keys
export const getApiKeys = (params: { page?: number, limit?: number }) =>
  request({
    url: '/admin/external/api-keys',
    method: 'get',
    params
  })

export const createApiKey = (data: {
  appName: string
  description?: string
  permissions?: string[]
  rateLimit?: number
  expiresAt?: string | null
}) =>
  request({
    url: '/admin/external/api-keys',
    method: 'post',
    data
  })

export const updateApiKey = (id: number, data: {
  appName?: string
  permissions?: string[]
  rateLimit?: number
  isActive?: boolean
  expiresAt?: string | null
  description?: string
}) =>
  request({
    url: `/admin/external/api-keys/${id}`,
    method: 'put',
    data
  })

export const getApiKeyUsageLogs = (id: number, params: { page?: number, limit?: number }) =>
  request({
    url: `/admin/external/api-keys/${id}/logs`,
    method: 'get',
    params
  })

// Bulk Grant
export const previewBulkGrant = (data: any) =>
  request({
    url: '/admin/bulk-grant/preview',
    method: 'post',
    data
  })

export const executeBulkGrant = (data: any) =>
  request({
    url: '/admin/bulk-grant/execute',
    method: 'post',
    data
  })

export const getBulkGrantHistory = (params: any) =>
  request({
    url: '/admin/bulk-grant/history',
    method: 'get',
    params
  })

export const getBulkGrantCountries = () =>
  request({
    url: '/admin/bulk-grant/countries',
    method: 'get'
  })

export const getBulkGrantFeatures = () =>
  request({
    url: '/admin/bulk-grant/features',
    method: 'get'
  })

export const getBulkGrantDeviceTypes = () =>
  request({
    url: '/admin/bulk-grant/device-types',
    method: 'get'
  })
